// extracted by mini-css-extract-plugin
module.exports = {"contact__markdown":"Contact_contact__markdown__joU2v","contact__content":"Contact_contact__content__3XQoW"};